import Metadata from './../requests/apa/Metadata';
import Asset from './../requests/apa/Asset';
import Translator from './../requests/apa/Translator';
import DeviceStorage from './../components/DeviceStorage/DeviceStorage';

class Parser {
  static parserModules(response) {
    if (response.response && response.response.modules) {
      return response.response.modules;
    }

    return {};
  }

  static parserList(response, url = null) {
    if (response.response && response.response.highlight) {
      return response.response.highlight;
    }
    if (response.response && response.response.groups) {
      if (url && url.includes('/v1/')) {
        return this.parserListForListVn(response);
      } else{
        return response.response.groups;
      }
    }

    return [];
  }

  static parserListForListVn(response){
    const list = response.response.groups.map(function(channel){
      let contentArray = [];
      contentArray = {
        channel_number:	null,
        date:	null,
        description:	channel.description.medium,
        description_large:	channel.description.long,
        duration:	channel.contentAttributes.duration,
        encoder_tecnology: 	null,
        episode_number:	channel.contentAttributes.episode,
        focusable:	channel.focusable,
        format_types:	channel.contentAttributes.marketingType,
        id:	channel.id,
        image_background:	channel.images.background,
        image_base_horizontal:	channel.images.horizontal,
        image_base_square:	null,
        image_base_vertical:	channel.images.vertical,
        image_clean_horizontal:	null,
        image_clean_square:	null,
        image_clean_vertical:	null,
        image_external:	null,
        image_frames:	null,
        image_large:	channel.images.large,
        image_medium:	channel.images.medium,
        image_small:	channel.images.small,
        image_sprites:	null,
        image_still:	null,
        image_trickplay:	null,
        is_series:	null,
        live_enabled:	null,
        live_ref:	null,
        live_type:	null,
        preview:	null,
        proveedor_code:	channel.provider.code,
        proveedor_name:	channel.provider.name,
        rating_code:	channel.rating.code,
        recorder_technology: 	null,
        resource_name:	null,
        rollingcreditstime:	null,
        rollingcreditstimedb:	null,
        season_number:	channel.contentAttributes.season,
        short_description:	null,
        source_uri:	null,
        timeshift:	null,
        title:	channel.title,
        title_episode:	channel.contentAttributes.episode,
        title_original:	channel.originalTitle,
        title_uri:	null,
        url_imagen_t1:	null,
        url_imagen_t2:	null,
        votes_average:	channel.votesAverage,
        year:	channel.contentAttributes.publishYear
      };
      return contentArray;
    });

    return list;
  }

  static parserListForRibbon(response, state){
    const list = response.response.groups.map(function(json){
      let swapArray = [];
      const label = (state !== 'myRecords') ? '' : json.title;
      swapArray = {
        group_id: json.id,
        id: json.id,
        label: label,
        href: `vcard/${json.id}`,
        clickHandler: () => { console.log(json.id + ' clicked') },
        cover: json.image_small,
        data_background: json.image_background
      };
      if(String(state) === 'myChannels') swapArray.href = `player/${json.id}`;
      return swapArray;
    });

    return list;
  }

  static parseSpecial(response) {

    const parser = {};
    parser.parser = 'parseSpecial';

    if (response.response && response.response.modules && response.response.modules.module) {
      const ribbons = response.response.modules.module;
      ribbons.forEach((item, index, array) => {
        parser[item.name] = {};
        parser[item.name].type = item.type;
        const components = item.components.component;
        components.forEach((citem, cindex, carray) => {
          switch (citem.name) {
            case 'background':
              parser[item.name][citem.name] = citem.properties.imglarge;
              break;
            case 'header':
              parser[item.name][citem.name] = citem.properties.medium;
              break;
            case 'carrousel':
              parser[item.name][citem.name] = {};
              parser[item.name][citem.name].id = citem.properties.id;
              parser[item.name][citem.name].type = citem.properties.type;
              parser[item.name][citem.name].url = citem.properties.url;
              break;
            default:
          }
        });

      });
    }
    return parser;
  }

  /**
   * Regresa un arreglo de objetos para las chapitas
   * @param {string} region        mexico|colombia|peru|...
   * @param {string} suscription   susc|no_susc|anonymous
   * @param {string} provider      FOX|FOX v3|HBO|NOGGIN|default
   * @param {string} format_types  est,ppe,free,susc
   * @param {string} live_enabled  0|1
   */
  static parserBadges(provider, format_types, live_enabled) {

    if (!format_types) {
      return [];
    }

    const config = JSON.parse(Metadata.get('providers_label_configuration'));
    let region = this.getRegion();
    const suscription = this.getSuscription();

    const results = [];
    try {
      if (!config[region]) {
        region = 'default';
      }

      if (config[region][suscription] && !config[region][suscription][provider]) {
        provider = 'default';
      }

      let arrFormatTypes = format_types.split(',');

      arrFormatTypes.map((formatType, aIndex) => {
        let vidoType = live_enabled && live_enabled == 1 ? "live" : "vod";
        if (config[region][suscription][provider][formatType] && config[region][suscription][provider][formatType][vidoType]) {
          let badges = config[region][suscription][provider][formatType][vidoType];
          badges.map((keys, index) => {

            let style = {};
            let result = {
              type: keys.type,
            };

            if (keys.type === 'text') {
              result.label = Translator.get(keys.text, '*Pendiente');
            } else if (keys.type === 'image') {
              result.src = Asset.get(keys.url);
            }

            const ignore = ['type', 'text', 'url'];

            for (var key in keys) {
              if (ignore.indexOf(key) === -1) {
                if (key === 'backgroundColor') {
                  if (keys[key].length > 6) {
                    var alpha = parseFloat(parseInt((parseInt(keys[key].substring(1, 3), 16) / 255) * 1000) / 1000);
                    style.opacity = alpha;
                    style.backgroundColor = "rgb(" + parseInt(keys[key].substring(3, 5), 16) + "," +
                      parseInt(keys[key].substring(5, 7), 16) + "," +
                      parseInt(keys[key].substring(7, 9), 16) + ")";
                  }
                }
                else {
                  style[this.parserBadgesCssProperties(key)] = keys[key];
                }
              }
            }
            result.style = style;
            results.push(result);
          });
        }
      });
    } catch (e) {
      console.error(e);
    }

    return results;
  }

  static parserBadgesCssProperties(prop) {
    switch (prop) {
      case 'gravity':
        return 'float';
      case 'textColor':
        return 'color';
      case 'textSize':
        return 'fontSize';
      default:
        return prop;
    }
  }

  //TODO: Implementar
  static getRegion() {
    return DeviceStorage.getItem('region') || 'mexico';
  }

  //TODO: Implementar
  static getSuscription() {
    return 'anonymous';
  }
}

export default Parser



// WEBPACK FOOTER //
// ./src/utils/Parser.js